export default __webpack_public_path__ + "static/media/734.89a3a988.png";